import React from "react";
import { Container } from "react-bootstrap";
import { Breadcrumb, LoginHeader} from "../../components";

function TipOfMonth() {

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Tip of the Month',
        },
    ];

    return(
        <>            
            <LoginHeader/>         
            <div className="main-content tipOfMonthPage">
                {/* page content */}
                <div className="pageContent">
                    <Container className="container-lg">
                        <Breadcrumb title="Tip of the Month" breadcrumb={breadcrumb}/>
                        <div className="tipBox">
                            <div className="tipBox_info">
                                <h2 className="font-md">Top 5 Reasons You Need an Annual Furnace Tune-Up</h2>
                                <p className="ft-14">Keeps You And Your Family Safe<br/>
                                Maintain Good System Operation<br/>
                                Reduces Emergency Repairs<br/>
                                Improves Energy Efficiency<br/>
                                Maintains Manufacturers Or Home Warranty</p>
                                <p className="ft-14">Learn More And Save $30 By Scheduling Your Appointment. (See Website Link Or Book In The App!)</p>
                                <a className="ft-14 text-500" target="_blank" rel="noreferrer" href="https://goodguys.app/top-5-reasons-you-need-an-annual-furnace-tune-up/">https://goodguys.app/top-5-reasons-you-need-an-annual-furnace-tune-up/</a>
                            </div>
                            <div className="tipBox_info">
                                <h2 className="font-md">Helping others…</h2>
                                <p className="ft-14">This Year May Be Tougher Than Ever For Some Families. Many Food Drives This Year Are Going Virtual. Please Take A Minute And Help Where You Can.</p>
                                <p className="ft-14">Maybe You Need Help This Year Or In A Place To Give This Year Please Consider Wheeler Mission. They Work Very Closely To Help Those Close To Home...</p>
                                <a className="ft-14 text-500" target="_blank" rel="noreferrer" href="https://wheelermission.org/">https://wheelermission.org/</a>
                            </div>
                            <div className="tipBox_info">
                                <h2 className="font-md">Why Choose Good Guys Home Service?</h2>
                                <p className="ft-14">Good Guys Home Service Is The Most Client-Focused HVAC And Plumbing Company In The Indianapolis Area. Our Team Has Been Earning Trust In Heating And Cooling Service, Installation, And Maintenance Plus Plumbing, Drain, And Sewer Service, Installation, And Maintenance. We Believe That The Most Important Choice You Have Is WHO Installs Or Repairs Your Air Conditioner, Furnace, Plumbing, Drains, And Sewer.</p>
                                <p className="ft-14">Good Guys Home Service Works To Provide The Best Client Experience Possible. If Something Goes Wrong With Your HVAC Or Plumbing Service, We Will Make It Right, Period. Our Client Assurance Manager Is Your Advocate, And She Will Make Sure That You Are Satisfied With A Job Done Correctly.</p>
                                <p className="ft-14">Book Here NOW !!</p>
                                <a className="ft-14 text-500" target="_blank" rel="noreferrer" href="https://goodguys.app/top-5-reasons-you-need-an-annual-furnace-tune-up/">https://goodguys.app/top-5-reasons-you-need-an-annual-furnace-tune-up/</a>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>
        </>
    );
}

export default TipOfMonth;